<template>
    <v-form ref="form" height="relative" class="pa-0 ma-0">
        <v-toolbar
          class="elevation-0 mt-n3 row-full py-0"
          height="relative"
          extension-height="relative"
        >
            <div class="container d-flex align-center py-1">
                <v-toolbar-title color="primary" class="headline font-weight-bold" style="line-height: 36px">{{ title }}</v-toolbar-title>
                <v-spacer></v-spacer>

                <!-- Clear Filters -->
                <v-btn
                    class="ma-0"
                    color="red darken-2"
                    @click="clearFilters"
                    v-if="
                            dateFilter.year !== undefined ||
                            dateFilter.month !== undefined ||
                            dateFilter.day !== undefined
                        "
                    text
                    depressed
                >
                    Clear Filters
                </v-btn>
            </div>
            <template v-slot:extension>
                <div class="container transition-fast-in-fast-out">
                    <v-row class="d-flex flex-row px-3">
                        <v-text-field
                            label="Search"
                            name="search"
                            v-model="searchTerm"
                            prepend-inner-icon="mdi-magnify"
                            clearable
                            flat
                            hide-details
                            solo
                            dense
                            background-color="#f8f8fd"
                            color="grey darken-4"
                            class="selection--teal search-field mr-3 mb-2"
                        />

                        <div class="d-flex flex-row mr-3 mb-2">
                            <div style="max-width:100px;" class="selection--teal">
                                <v-select
                                    flat
                                    v-model="dateFilter.year"
                                    item-value="year"
                                    item-text="year"
                                    id="year"
                                    :items="dateFilterYearOptions"
                                    hide-details
                                    solo
                                    dense
                                    menu-props="offset-y"
                                    width="160px"
                                    background-color="#f8f8fd"
                                    color="grey darken-4"
                                    item-color="primary"
                                    prefix="Year"
                                    class="selection--teal"
                                    clearable
                                    @click:clear="clearFilters('year')"
                                    @change="filter('year')"
                                >
                                </v-select>
                            </div>
                            <div style="max-width:100px;" class="mx-1">
                                <v-select
                                    flat
                                    :items="months"
                                    item-value="value"
                                    item-text="name"
                                    id="month"
                                    v-model="dateFilter.month"
                                    :disabled="!dateFilter.year || dateFilter.year.length === 0"
                                    hide-details
                                    solo
                                    dense
                                    menu-props="offset-y"
                                    width="160px"
                                    background-color="#f8f8fd"
                                    color="grey darken-4"
                                    item-color="primary"
                                    prefix="Month"
                                    class="selection--teal"
                                    clearable
                                    @click:clear="clearFilters('month')"
                                    @change="filter('month')"
                                >
                                </v-select>
                            </div>
                            <div style="max-width:100px;">
                                <v-select
                                    flat
                                    :items="daysInMonth"
                                    item-value="day"
                                    id="day"
                                    v-model="dateFilter.day"
                                    :disabled="!dateFilter.month || dateFilter.year.month === 0"
                                    hide-details
                                    solo
                                    dense
                                    menu-props="offset-y"
                                    width="160px"
                                    background-color="#f8f8fd"
                                    color="grey darken-4"
                                    item-color="primary"
                                    prefix="Day"
                                    class="selection--teal"
                                    clearable
                                    @click:clear="clearFilters('day')"
                                    @change="filter('day')"
                                >
                                </v-select>
                            </div>
                        </div>

                        <v-select
                            v-model="status"
                            :items="statuses"
                            menu-props="offset-y"
                            background-color="#f8f8fd"
                            color="grey darken-4"
                            item-color="primary"
                            prefix="Status"
                            class="selection--teal shrink mr-3 mb-2"
                            hide-details
                            solo
                            dense
                            clearable
                            flat
                            @click:clear="filter"
                            @change="filter"
                        />

                        <v-btn
                          class="mb-2"
                          color="primary"
                          text
                          @click="exportDialog = true"
                        >
                            Export
                        </v-btn>
                    </v-row>
                </div>
            </template>
        </v-toolbar>
        <v-dialog
            v-model="exportDialog"
            width="500"
        >
            <v-card flat>
                <v-card-title class="text-center">
                  <h2 class="font-20 text-center">Export Data</h2>
                </v-card-title>
                <v-card-text>
                    <div class="d-flex flex-column default-font">
                        <h4 class="subtitle-1 text-center">How would you like to export?</h4>
                        <div class="export__wrapper d-flex justify-center  mt-4">
                            <div
                                v-for="fileFormat in fileFormats"
                                :key="fileFormat"
                                class="export__content"
                                @click="emitExport(fileFormat)"
                            >
                                <div class="export__logo">
                                    <v-avatar class="align-self-center text-center" tile size="64">
                                        <img :src="`/svg/${fileFormat}.svg`"/>
                                    </v-avatar>
                                </div>
                                <span class="caotion mt-2 text-center">Export as {{ toUpper(fileFormat) }}</span>
                            </div>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

    </v-form>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        props: {
            title: {
                type: String,
                default: 'Transfers',
            },
            isRequests: {
                type: Boolean,
                default: false,
            },
        },
        data,
        computed: getComputed(),
        methods: getMethods(),
        filters: getFilters(),
        watch: {
            searchTerm() {
              if (this.searchDebounce) {
                  clearTimeout(this.searchDebounce);
              }

              this.searchDebounce = setTimeout(() => {
                  this.filter();
              }, 300);
            },
        }
    };

    function data() {
        return {
            filteringByDate: false,
            dateFilter: {
                month: undefined,
                day: undefined,
                year: undefined,
            },
            months: [
                { value: '01', name: 'January' },
                { value: '02', name: 'February' },
                { value: '03', name: 'March' },
                { value: '04', name: 'April' },
                { value: '05', name: 'May' },
                { value: '06', name: 'June' },
                { value: '07', name: 'July' },
                { value: '08', name: 'August' },
                { value: '09', name: 'September' },
                { value: '10', name: 'October' },
                { value: '11', name: 'November' },
                { value: '12', name: 'December' },
            ],
            status: null,
            searchTerm: null,
            searchDebounce: null,
            exportDialog: false,
            fileFormats: [
              'pdf',
              'xlsx',
            ],
        };
    }

    function getMethods() {
        return {
            getFiltersPayload,
            filter,
            clearFilters,
            emitExport,
            toUpper(str) {
              return str.toUpperCase();
            },
        };

        function getFiltersPayload(value) {
            const vm = this;
            let payload = {
                state: this.status,
            };

            if (this.searchTerm) {
              payload.search = this.searchTerm;
            }

            function resolveDateConflicts() {
                // If month value is changed and the value of the selected day (if any)
                // is higher than the number of days in the month, set day to null.
                // If 2020/03/31 is selected, and the user changes to 2019/02/31,
                // date will change to 2019/02/--
                if (value === 'month' && vm.dateFilter.day > vm.daysInMonth.length) {
                    vm.dateFilter.day = '';
                // If year is changed and the value of the selected day (if any)
                // is higher than the number of days in the month, set day to null.
                // If 2020/02/29 is selected, and the user changes to 2019/02/29,
                // date will change to 2019/02/--
                } else if (value === 'year' && vm.dateFilter.day > vm.daysInMonth.length) {
                    vm.dateFilter.day = '';
                }
            }

            if (vm.dateFilter.year && vm.dateFilter.month && vm.dateFilter.day) {
                resolveDateConflicts();
            }

            if (vm.dateFilter.year && !vm.dateFilter.month) {
                payload.start_date = `${vm.dateFilter.year}-01-01`;
                payload.end_date = `${vm.dateFilterEndDate.year}-${vm.dateFilterEndDate.month}-${vm.dateFilterEndDate.day}`;
                this.filteringByDate = true;
            } else if (vm.dateFilter.year && vm.dateFilter.month && !vm.dateFilter.day) {
                payload.start_date = `${vm.dateFilter.year}-${vm.dateFilter.month}-01`;
                payload.end_date = `${vm.dateFilterEndDate.year}-${vm.dateFilterEndDate.month}-01`;
                this.filteringByDate = true;
            } else if (vm.dateFilter.year && vm.dateFilter.month && vm.dateFilter.day) {
                payload.start_date = `${vm.dateFilter.year}-${vm.dateFilter.month}-${vm.dateFilter.day}`;
                payload.end_date = `${vm.dateFilterEndDate.year}-${vm.dateFilterEndDate.month}-${vm.dateFilterEndDate.day}`;
                this.filteringByDate = true;
            } else {
                this.filteringByDate = false;
            }

            const startDate = moment(payload.start_date, ['YYYY-MM-DD', 'YYYY-M-DD', 'YYYY-MM-D', 'YYYY-M-D']);
            const endDate = moment(payload.end_date, ['YYYY-MM-DD', 'YYYY-M-DD', 'YYYY-MM-D', 'YYYY-M-D']);

            if (startDate.isValid()) {
                payload.start_date = startDate.tz('UTC').format();
            }

            if (endDate.isValid()) {
                payload.end_date = endDate.tz('UTC').format();
            }

            return payload;
        }

        function filter(value) {
            const payload = this.getFiltersPayload(value);
            this.$emit('filter', payload);
        }

        function clearFilters(value) {
            const vm = this;

            if (value === 'day') {
                vm.dateFilter.value = null;
            } else if (value === 'month') {
                vm.dateFilter.value = null;
                vm.dateFilter.day = null;
            } else if (value === 'year') {
                vm.dateFilter.value = null;
                vm.dateFilter.month = null;
                vm.dateFilter.day = null;
            } else {
                vm.$refs.form.reset();
            }
        }

        function emitExport(format) {
            const payload = this.getFiltersPayload();
            this.$emit('export', {
              ...payload,
              format,
            });
        }
    }

    function getComputed() {
        return {
            dateFilterYearOptions,
            dateFilterEndDate,
            daysInMonth,
            statuses() {
                if (this.isRequests) {
                    return [
                        {
                            text: 'Accepted',
                            value: 'accepted',
                        },
                        {
                            text: 'Cancelled',
                            value: 'cancelled',
                        },
                        {
                            text: 'Completed',
                            value: 'completed',
                        },
                        {
                            text: 'Declined',
                            value: 'declined',
                        },
                        {
                            text: 'Expired',
                            value: 'expired',
                        },
                        {
                            text: 'Pending',
                            value: 'pending',
                        },
                    ];
                }

                return [
                    {
                        text: 'Cancelled',
                        value: 'cancelled',
                    },
                    {
                        text: 'Completed',
                        value: 'completed',
                    },
                    ...(
                        this.$_user.can_post_offers
                            ? [
                                {
                                    text: 'Expired',
                                    value: 'expired',
                                },
                            ] : []
                    ),
                ];
            },
        };

        function dateFilterYearOptions() {
            var years = [];
            var dt = new Date();
            for (let x = 2018; x <= dt.getFullYear(); x++) {
                years.push(x);
            }
            return years;
        }

        function dateFilterEndDate() {
            const vm = this;
            let workingDate, endDate, endDay, endMonth, endYear;

            function createWorkingDates() {
                // If day & month aren't yet selected, set workingdate to the 1st day of the year
                // end date is next year
                if (!vm.dateFilter.day && !vm.dateFilter.month) {
                    workingDate = Vue.moment(
                        `${vm.dateFilter.year}-1-1`,
                        'YYYY-M-D',
                        true,
                    );
                    endDate = workingDate.add(1, 'year');

                // if day is not yet selected, set workingdate to the 1st day of the month
                // end date is next month
                } else if (!vm.dateFilter.day) {
                    workingDate = Vue.moment(
                        `${vm.dateFilter.year}-${vm.dateFilter.month}-1`,
                        'YYYY-M-D',
                        true,
                    );
                    endDate = workingDate.add(1, 'month');

                // otherwise set selected date as workingdate
                // end date is next day
                } else if (vm.dateFilter.day) {
                    workingDate = Vue.moment(
                        `${vm.dateFilter.year}-${vm.dateFilter.month}-${vm.dateFilter.day}`,
                        'YYYY-M-D',
                        true,
                    );
                    endDate = workingDate.add(1, 'day');
                }
            }

            function createEndDates(endDate) {
                endDay = endDate.format('D');
                endMonth = endDate.format('M');
                endYear = endDate.format('YYYY');
            }

            createWorkingDates();
            createEndDates(endDate);

            return {
                year: endYear,
                month: endMonth,
                day: endDay,
            };
        }

        function daysInMonth() {
            // Get date from year/month select fields
            const workingDate = Vue.moment(
                `${this.dateFilter.year}-${this.dateFilter.month}`,
                'YYYY-MM',
                true,
            );

            if (workingDate.isValid()) {
                let n = workingDate.daysInMonth();
                let payload = [];

                // if statement for leap year compatibility
                if (workingDate.isLeapYear() && this.dateFilter.month.value === 2) {
                    n += 1;
                    for (var i = 1; i <= n; i++) {
                        payload.push(i);
                    }
                    return payload;
                } else {
                    for (var i = 1; i <= n; i++) {
                        payload.push(i);
                    }
                    return payload;
                }
            }
        }
    }

    function getFilters() {
        return {
            leadingZeros,
        };

        function leadingZeros(value) {
            return String(value).padStart(2, '0');
        }
    }
</script>

<style scoped>
.row-full {
    width: 100vw;
    position: relative;
    margin-left: -50vw;
    left: 50%;
}

.v-toolbar.row-full {
    width: 100vw;
    position: absolute;
    margin-left: -50vw;
    left: 50%;
}

.mt-10 {
    margin-top: 10em !important;
}

.mt-24 {
    margin-top: 96px !important;
}

.selection--teal .v-select__selection.v-select__selection--comma {
    color: #4DB6AC;
}

.selection--teal >>> .v-text-field__prefix {
    margin-top: -2px !important;
}

.selection--teal >>> .v-select__slot {
    font-size: .876rem !important;
    font-weight: 500 !important;
    letter-spacing: 1.095px;
}

.search-field {
  width: 200px;
}

.export__content {
  box-sizing: border-box;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 0.5rem;
  padding: 0.5rem;
}

.export__content:hover {
  background-color: #EAF0F5;
}

@media screen and (max-width: 600px) {
    .search-field {
        width: 100%;
    }
}
</style>
